import type { ActiveCampaignSubscriberStatus } from '@/lib/integrations/activecampaign/types';
import type { MailchimpSubscriberStatus } from '@/lib/integrations/mailchimp/types';

/** Validate a raw property string against an allowed set of status values. */
export function toValidatedStatus<T extends string>(
  raw: string | null | undefined,
  valid: readonly T[]
): T | undefined {
  if (raw == null) {
    return undefined;
  }
  return valid.find(s => s === raw);
}

const VALID_MAILCHIMP_STATUSES: readonly MailchimpSubscriberStatus[] = [
  'subscribed',
  'unsubscribed',
  'pending',
  'cleaned',
  'transactional',
  'archived',
  'not_synced',
];

export function toMailchimpStatus(
  raw: string | null | undefined
): MailchimpSubscriberStatus | undefined {
  return toValidatedStatus(raw, VALID_MAILCHIMP_STATUSES);
}

const VALID_ACTIVECAMPAIGN_STATUSES: readonly ActiveCampaignSubscriberStatus[] =
  ['subscribed', 'unsubscribed', 'bounced', 'synced'];

export function toActiveCampaignStatus(
  raw: string | null | undefined
): ActiveCampaignSubscriberStatus | undefined {
  return toValidatedStatus(raw, VALID_ACTIVECAMPAIGN_STATUSES);
}
